import {
  MDBContainer,
  MDBRow,
  MDBIcon
} from 'mdb-react-ui-kit';

import Navbar from './components/Navbar';
import SketchfabConfigurator from './components/SketchfabConfigurator';
import ModelLibarary from './components/ModelLibrary'
import DiscoverFeature from './components/DiscoverFeature';
import ModelManager from './components/ModelManager';
import PlayerTop from './components/PlayerTop';
import TopInfo from './components/TopInfo';
import ModelBuilder from './components/ModelBuilder';

import Footer from './components/common/Footer';
import ContactUsForm from './components/common/ContactUsForm';
import { Card } from 'react-bootstrap';
import ContactBtn from './components/common/ContactBtn';
import WatchVideoBtn from './components/common/WatchVideoBtn';
import ScrollButton from './components/common/ScrollButton';

function MainPage(){

    return (
    <>
    {/* Top Mover */}
      <ScrollButton/>
      <section className='NAVBAR'>
	  <Navbar />
    </section>

    <MDBContainer fluid>
    <MDBRow >
    <section className='top-info-1 mt-1'>
        {/* <video width="100%" loop={true} autoPlay="autoPlay" id="vid" muted playsInline>
        <source src="video/gti-website-resources.mp4" type="video/mp4" />
        </video> */}

          <Card className="bg-transparent shadow-0 border-0 text-white">
            <Card.Img src="Image/gti-website-resources.jpg" alt="Card image" className=" w-100 p-0 m-0" />
            <Card.ImgOverlay className="p-0 m-0">
              <video className='p-0 w-100' loop={true} autoPlay preload='auto' muted playsInline>
                <source src="video/gti-website-resources.mp4" type="video/mp4" />
              </video>
            </Card.ImgOverlay>
          </Card>
    </section>
    </MDBRow>

<section id='SOLUTIONS'>
    <MDBRow>
      <section className='info-2 d-flex flex-row justify-content-center'>
      <TopInfo />
      </section>
    </MDBRow>
    <br />
    <WatchVideoBtn/>
      <br />
    <div className="bar-break d-flex justify-content-center align-content-center ">
      <div className="mainBar">
      </div>
    </div>
    </section>
    <MDBRow id='PLAYER'>    
    <section className="player-top d-flex flex-row justify-content-center">
        <PlayerTop/>
    </section>
    </MDBRow>

		<MDBRow id='CONFIGURATOR'>
			<section className='sketchfab-configurator flex-row justify-content-center'>
				<SketchfabConfigurator/>
			</section>
		</MDBRow> 

<br />
      <ContactBtn/>

      <br />
      <div className="bar-break d-flex justify-content-center align-content-center ">
      <div className="mainBar">
      </div>
    </div>
      <br />

		<MDBRow id='LIBRARY'>
			<section className='flex-row justify-content-center'>
				<ModelLibarary/>

			</section>
      <br />
		</MDBRow>
    
    <br />

      <div className="bar-break d-flex justify-content-center align-content-center ">
      <div className="mainBar">
      </div>
    </div>
      <br />

    <MDBRow id='MANAGER'>
			<section className=' d-flex  justify-content-center'>
				<ModelManager/>
			</section>
      <br />
		</MDBRow>
        <MDBRow>
          <p className=' top-title-3 text-center'>Take the reins of your 3D assets and elevate your digital content delivery.</p>
        <section className='discoverFeature d-flex justify-content-center  my-2'>
        <DiscoverFeature/>
        </section>
      </MDBRow>
      <br />
      <ContactBtn/>

<br />

      <div className="bar-break d-flex justify-content-center align-content-center ">
      <div className="mainBar">
      </div>
    </div>
      <br />

      <MDBRow id='BUILDER'>
      <section className=' d-flex flex-column justify-content-center align-items-center '>
				<ModelBuilder/>
			</section>
      <br />
      </MDBRow>
      <MDBRow>
      <section className='px-0'>

				<Footer />
			</section>
      </MDBRow>



    </MDBContainer>
    </>

  );
}
export default MainPage;